const HELP_CENTER_DISABLED_PATHNAMES = new Set([
  '/quiz/[id]',
  '/play/[entryMapHashId]',
  '/update-browser',
  '/policy',
  '/terms',
  '/build',
  '/update/[id]',
  '/duplicate/[id]',
]);

export function isHelpCenterDisabledPathname(pathname: string) {
  return (
    HELP_CENTER_DISABLED_PATHNAMES.has(pathname) ||
    pathname.startsWith('/admin')
  );
}
